import requestAction from '../../utils/requestAction'
import InvoiceStatus from '../../models/InvoiceStatus';

export const upsertInvoiceStatus = (invoiceStatus: InvoiceStatus, handleResponse?: (invoiceStatusId: number) => void) =>
 requestAction('INVOICESTATUS_UPSERT')(
    `invoiceStatus${invoiceStatus.id ? `/${invoiceStatus.id}` : ''}`,
    invoiceStatus.id ? 'PUT' : 'POST',
    invoiceStatus,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.invoiceStatusId) })
      
      